//let root_url = 'http://127.0.0.1:8000/'
let root_url = 'https://admin.getprephub.com/'

export default root_url
